module.exports = __webpack_public_path__ + "img/02.d88f26aa.webp";